const MenuItem = [
    {
        title: 'Home',
        id: "home",
        link: "/"
    }, {
        title: 'Blogs',
        id: "blogs",
        link: "https://blog.detstudy.com/",
        unaunthenticated: true
    }, {
        title: 'Videos',
        id: "videos",
        link: "https://www.youtube.com/@detstudy",
        unaunthenticated: true
    }, {
        title: '10% Discount Code',
        id: "ten_percent_discount_code",
        link: "#buy-coupon-section"
    }, {
        title: 'FAQs',
        id: "faqs",
        link: "#faq-section"
    }
]


export default MenuItem;
